import React, { Component } from 'react'
import { DropDownForm } from 'controls/DropDown'

import { Field, reduxForm } from 'redux-form'
import { RadioButtonsForm } from 'controls'

import { months, rangeOptions } from './config'
import { controlsStyle } from './styles'

class Controls extends Component {
  render() {
    const { handleSubmit } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <div className="form-controls-content">
          <div className="month">
            <p className="label">Mes:</p>
            <Field
              name="month"
              id="month"
              component={DropDownForm}
              options={months}
            />
          </div>
          <div className="range">
            <Field
              placeholder="Días del mes"
              name="range"
              id="range"
              component={RadioButtonsForm}
              orientation="horizontal"
              options={rangeOptions}
            />
          </div>
        </div>
        <style jsx>{controlsStyle}</style>
      </form>
    )
  }
}

const formConfig = {
  form: 'searchPortalsStats'
}

export const ControlsForm = reduxForm(formConfig)(Controls)
